<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import EmptyLayout from "@/components/models/message/empty/EmptyLayout.vue";

definePage({ meta: { layout: "rooms" } });
</script>

<template>
  <empty-layout />
</template>
